import { render, staticRenderFns } from "./MaintenanceAlert.vue?vue&type=template&id=2bbd8d2e&"
import script from "./MaintenanceAlert.vue?vue&type=script&lang=js&"
export * from "./MaintenanceAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports